<script setup lang="ts">
import type { FormKitFrameworkContext } from '@formkit/core'
import { onClickOutside, useDebounceFn } from '@vueuse/core'
import { ref } from 'vue'
import { createMessage } from '@formkit/core'

const props = defineProps<{
  context: FormKitFrameworkContext
}>()

const { t } = useI18n()

const matches = ref<AutocompleteData[]>([])
const selection = ref<AutocompleteData | null>(null)

const context = props.context
const node = context.node
if (!context._value) {
  context._value = {}
  context._value.address = ''
  context._value.location = {}
}

const ul = ref(null)

onClickOutside(ul, () => {
  matches.value = []
  node.store.remove('required')
  if (!selection.value) {
    const message = createMessage({
      key: 'required',
      value: node.props.validationMessages?.required as string,
      blocking: true,
    })

    node.store.set(message)
  }
})

function handleInput(e: Event) {
  const target = e.target as HTMLInputElement
  node.props.address = target.value
  node.input({ address: node.props.address })

  if (node.props.address === '') {
    node.input('')
    matches.value = []
    return
  }

  getAutocompleteDataDebounced(node.props.address)
}

function handleKeyDown(e: KeyboardEvent) {
  // switch (e.key) {
  //   case 'Enter':
  //     return setAddressOnEnter()
  //   case 'ArrowDown':
  //     e.preventDefault()
  //     const target = e.target as HTMLInputElement
  //     return select(1)
  //   case 'ArrowUp':
  //     e.preventDefault()
  //     return select(-1)
  // }
}

// function select(delta: 1 | -1) {
//   const available = matches.value

//   let idx = 0

//   if (selection.value === undefined) {
//     idx = 0
//   } else {
//     idx = available.findIndex((e) => e.id === selection.value!.id) + delta
//   }

//   if (idx >= available.length) {
//     idx = 0
//   } else if (idx < 0) {
//     idx = available.length - 1
//   }

//   selection.value = available[idx]
// }

function setAddressOnClick(e: Event) {
  const target = e.target as HTMLLIElement
  setAddress(target.textContent as string)
}

// function setAddressOnEnter() {
//   if (selection.value === undefined) return
//   setAddress(selection.value.address.label)
// }

function setAddress(address: string) {
  const selected =
    matches.value.find((item: any) => item.address === address) || null
  selection.value = selected
  node.props.address = address
  node.props.location = selected
    ? {
        longitude: selected.longitude,
        latitude: selected.latitude,
      }
    : {}
  matches.value = []
  selection.value = null
  node.store.remove('required')
  node.input({ address: node.props.address, location: node.props.location })
}

async function getAutocompleteData(addressQuery: string) {
  const response = await fetchAutocompleteData(addressQuery, {
    filter: { street: true },
  })
  if (response && response.length > 0) {
    node.store.remove('no-results')
    matches.value = response
  } else {
    matches.value = []
    node.store.remove('required')
    const message = createMessage({
      key: 'no-results',
      value: t('dbc-osm-no-results'),
      blocking: true,
    })
    node.store.set(message)
  }
}

const getAutocompleteDataDebounced = useDebounceFn((addressQuery: string) => {
  getAutocompleteData(addressQuery)
}, 200)
</script>

<template>
  <input
    @input="(e: Event) => handleInput(e)"
    @keydown="(e: KeyboardEvent) => handleKeyDown(e)"
    :name="node.name"
    :value="context!._value.address"
    :placeholder="context!.attrs.placeholder"
    :id="context!.id"
    class="formkit-input"
    :class="context?.classes.input"
  />

  <ul v-if="matches.length > 0" class="dbc-c-autocomplete__items" ref="ul">
    <li
      v-for="match in matches"
      @click="(e: Event) => setAddressOnClick(e)"
      :data-selected="selection ? selection.id === match.id : null"
      class="dbc-c-autocomplete__item"
    >
      {{ match.address }}
    </li>
  </ul>
</template>
